import {useAppSelector} from "../app/hooks";
import {getIsAuthorized} from "../features/auth/authSlice";
import {Navigate, Outlet} from "react-router-dom";

export const AuthRoute = () => {
    const isAuthorized = useAppSelector(getIsAuthorized);

    return isAuthorized ? <Navigate to={'/panel/bons/charge'} /> : <Outlet />
}